<template>
  <div>
    <h3 class="mb-4"><strong>Add to hike list</strong></h3>

    <div v-for="hikeList of this.usersHikeLists" :key="hikeList.id">
      <div class="row p-0 m-0">
        <div class="input-group col-12 p-0 m-0 d-flex align-items-center justify-content-between">
          <span class="py-2 border-0"><p class="m-0">{{hikeList.name}}</p></span>
          <span class="input-group-append">
          <button class="btn btn-block btn-link d-flex align-items-center" type="button" @click="toggleHikeInList(hikeList)">
            <template v-if="hikeListIncludesHike(hikeList)">
              <span class="material-icons text-yellow">check</span>
            </template>
            <template v-else>
              <span class="material-icons text-muted">add</span>
            </template>
          </button>
        </span>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 p-0 m-0">
          <hr class="my-1">
        </div>
      </div>
    </div>

    <div class="row p-0 m-0">
      <div class="input-group col-12 p-0 m-0 d-flex align-items-center">
        <input class="form-control py-2 border-0" style="background: #17181d" placeholder="Create a new list" @keyup.enter="createHikeList" v-model="hikeListName">
        <span class="input-group-append">
          <button class="btn btn-block btn-link d-flex align-items-center" type="button" @click="createHikeList">
            <span class="material-icons text-muted">add</span>
          </button>
        </span>
      </div>
    </div>

    <div class="row p-0 m-0">
      <div class="col-12 p-0 m-0">
        <hr class="my-1">
      </div>
    </div>
    <!-- <button class="btn btn-primary" @click="closeClicked">Close</button> -->
  </div>
</template>

<script>

import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      hikeListName: '',
    };
  },
  async mounted() {
    await this.$store.dispatch('onBoarding/getUserHikeLists');
  },
  computed: {
    usersHikeLists: {
      get() {
        return this.$store.state.onBoarding.usersHikeLists;
      },
    },
    hikeId: {
      get() {
        return this.$store.state.onBoarding.hikeId;
      },
    },
  },
  methods: {
    toggleHikeInList(hikeList) {
      this.$store.dispatch('onBoarding/toggleHikeInList', hikeList);
    },
    async createHikeList() {
      if (this.hikeListName === '') {
        return alert('Please add a name for your list');
      }
      try {
        await this.$store.dispatch('onBoarding/createHikeList', this.hikeListName);
        this.hikeListName = '';
      } catch (e) {
        alert(e);
      }
    },
    async closeClicked() {
      this.$modal.classList.toggle('open');
    },
    hikeListIncludesHike(hikeList) {
      return hikeList.hikes?.some((hike) => hike.id === this.hikeId || hike.id === String(this.hikeId)) || false;
    },
  },
});
</script>

<style scoped>

</style>
